var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};
export default isNumeric;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/_util/isNumeric.js
// module id = 289
// module chunks = 0